import { gql } from '@apollo/client';

export const UPDATE_CREDIT_SUBMISSION = gql`
  mutation UpsertCreditSubmission($input: UpsertCreditSubmissionInput!) {
    upsertCreditSubmission(input: $input) {
      id
    }
  }
`;
